import { z } from 'zod';
import type { File as DeploymentFileOriginal } from '@wix/ambassador-velo-backend-v1-app-deployment/types';
import { CloudProvider } from '@wix/ambassador-velo-backend-v1-app-deployment/types';

export type BackendFile = Required<DeploymentFileOriginal>;

const staticFileMetadata = z.object({
  path: z.string(),
  hash: z.string(),
  size: z.number().optional(),
  contentType: z.string(),
});

export type StaticFileMetadata = z.infer<typeof staticFileMetadata>;

const StaticFileUploadUrlSchema = z.object({
  uploadUrl: z.string().url(),
  staticFileMetadata,
});

const AppDeploymentSchema = z
  .object({
    id: z.string().uuid(),
    deploymentBaseUrl: z.string(),
    cloudProviderOverride: z.nativeEnum(CloudProvider),
  })
  // Only required fields from AppDeployment are included,the rest are ignored for simplicity.
  .passthrough();

export const CompleteAppDeploymentSchema = z.object({
  appDeployment: AppDeploymentSchema,
});

export const AppEnvironmentSchema = z.object({
  appEnvironment: z
    .object({
      id: z.string(),
      variables: z.record(z.string()),
      secrets: z.record(z.string()),
    })
    .passthrough(),
});

export type AppEnvironment = z.infer<
  typeof AppEnvironmentSchema
>['appEnvironment'];

export const AppProjectSchema = z.object({
  appProject: z.object({
    id: z.string().uuid(),
    baseUrl: z.string().url(),
  }),
});

export const CreateAppProjectSchema = z.object({
  appProject: z.object({
    id: z.string().uuid(),
    baseUrl: z.string().url(),
  }),
});

export const CreateAppDeploymentSchema = z.object({
  staticFilesUploadUrls: z.array(StaticFileUploadUrlSchema).optional(),
  uploadAuthToken: z.string().optional(),
  appDeployment: AppDeploymentSchema.optional(),
  uploadBuckets: z
    .array(
      z.object({
        hashes: z.array(z.string()).optional(),
      })
    )
    .optional(),
});

export const StaticFileUploadSchema = z
  .object({
    result: z
      .object({
        // The `jwt` field is optional because it is only returned in the last file upload.
        jwt: z.string().optional(),
      })
      .optional(),
  })
  .passthrough();
